import React from "react";
import ButtonWithLoading from "components/button-with-loading";
import classNames from "classnames";
import { PermissionGate } from "permissions/components/gate";
import HeaderPortal from "components/portal/header-portal";

export function FormActions({
  rule,
  collection,
  isNewItem,
  isCreating,
  isUpdating,
  isDirty,
  createItem,
  updateItem,
  createText = "Save",
  updateText = "Update",
  className,
  teleport = true,
  disabled = false,
}) {
  const FormActionsCommon = () => {
    return isNewItem ? (
      <ButtonWithLoading
        variant="default"
        isLoading={isCreating}
        onClick={createItem}
      >
        {createText}
      </ButtonWithLoading>
    ) : (
      <ButtonWithLoading
        variant="default"
        isLoading={isUpdating}
        disabled={!isDirty || disabled}
        onClick={updateItem}
      >
        {updateText}
      </ButtonWithLoading>
    );
  };

  if (!teleport) {
    return (
      <div className={classNames("flex gap-4 items-center", className)}>
        {isNewItem ? (
          <ButtonWithLoading
            variant="default"
            isLoading={isCreating}
            onClick={createItem}
            disabled={!isDirty}
          >
            {createText}
          </ButtonWithLoading>
        ) : (
          <ButtonWithLoading
            variant="default"
            isLoading={isUpdating}
            disabled={!isDirty || disabled}
            onClick={updateItem}
          >
            {updateText}
          </ButtonWithLoading>
        )}
      </div>
    );
  }

  if (rule && collection) {
    return (
      <HeaderPortal>
        <PermissionGate
          rule={rule}
          collection={collection}
          fallback={
            <div className="text-sm text-gray-500 italic">
              You don't have permission to perform this action
            </div>
          }
        >
          <FormActionsCommon />
        </PermissionGate>
      </HeaderPortal>
    );
  }

  return (
    <HeaderPortal>
      <FormActionsCommon />
    </HeaderPortal>
  );
}
